import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import Logo from "./Logo";
import { SERVICE_PAGES } from "../lib/api";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-navy-950 text-white overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 bg-arch-dark" aria-hidden="true" />
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[720px] h-[420px] rounded-full bg-royal/20 blur-[120px]" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-8">
          <div className="md:col-span-5">
            <Logo dark />
            <p className="mt-5 text-[15px] leading-relaxed text-ice/80 max-w-sm">
              Helping Good Businesses Keep More of What They Earn.
            </p>
            <p className="mt-4 text-xs font-bold uppercase tracking-wider2 text-teal-bright">
              A Division of Community Promotions
            </p>
            <p className="text-xs text-ice/60 mt-1">Helping Businesses Grow Since 2001</p>
            <div className="mt-6 space-y-2.5 text-sm text-ice/70">
              <a href="mailto:admin@communitypromotionsllc.com" data-testid="footer-email" className="flex items-center gap-2.5 hover:text-teal-bright transition-colors w-fit">
                <Mail className="w-4 h-4 text-teal-bright shrink-0" />
                admin@communitypromotionsllc.com
              </a>
              <a href="tel:+18643160078" data-testid="footer-phone" className="flex items-center gap-2.5 hover:text-teal-bright transition-colors w-fit">
                <Phone className="w-4 h-4 text-teal-bright shrink-0" />
                (864) 316-0078
              </a>
            </div>
          </div>

          <nav className="md:col-span-2" aria-label="Services">
            <p className="text-[11px] font-bold uppercase tracking-wider2 text-ice/50 mb-4">Savings Services</p>
            <ul className="space-y-2.5">
              {Object.values(SERVICE_PAGES).map((s) => (
                <li key={s.key}>
                  <Link to={s.path} data-testid={`footer-service-${s.key}`} className="text-sm text-ice/75 hover:text-teal-bright transition-colors">
                    {s.short}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="md:col-span-2" aria-label="Company">
            <p className="text-[11px] font-bold uppercase tracking-wider2 text-ice/50 mb-4">Company</p>
            <ul className="space-y-2.5">
              <li><Link to="/" data-testid="footer-home" className="text-sm text-ice/75 hover:text-teal-bright transition-colors">Home</Link></li>
              <li><Link to="/about" data-testid="footer-about" className="text-sm text-ice/75 hover:text-teal-bright transition-colors">About Us</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="text-sm text-ice/75 hover:text-teal-bright transition-colors">Contact / Savings Review</Link></li>
            </ul>
          </nav>

          <nav className="md:col-span-3" aria-label="Legal">
            <p className="text-[11px] font-bold uppercase tracking-wider2 text-ice/50 mb-4">Legal</p>
            <ul className="space-y-2.5">
              <li><Link to="/privacy" data-testid="footer-privacy" className="text-sm text-ice/75 hover:text-teal-bright transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-terms" className="text-sm text-ice/75 hover:text-teal-bright transition-colors">Terms of Use</Link></li>
            </ul>
            <div className="mt-6 rounded-xl border border-white/10 bg-white/5 p-4">
              <p className="text-[11px] leading-relaxed text-ice/55">
                Bottom Line Improvements may receive referral compensation when customers choose services through
                participating provider relationships. Evaluations are performed by independent specialists.
              </p>
            </div>
          </nav>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-ice/50">© {year} Bottom Line Improvements. All rights reserved.</p>
          <p className="text-xs text-ice/50">
            Bottom Line Improvements is not an insurance provider, accounting practice, or tax advisory firm.
          </p>
        </div>
      </div>
    </footer>
  );
}
